import React, { useState } from "react";
import { hadleFilter } from "../../../Utils/filtroBusqueda";
import { InputField } from "../../../Components/FormElements/InputField";
import DateTimePicker from "react-datetime-picker";
import IconDelete from "../../../Resources/svg/Icons/IconDelete";
import CalendarIcon from "../../../Resources/svg/date-picker.svg";
import { useForm } from "react-hook-form";
import moment from "moment";

export const InputsSearchRV = ({
  onSubmit,
  handleReset,
  codProd,
  setActiveOptionButton,
  activeOptionButton,
  handleDate
}: any) => {

  const [selectedDateXML, setSelectedDateXML] = useState<Date | null>(null);
  const [selectedDateClosingDate, setSelectedDateClosingDate] = useState<Date | null>(null);

    const {
      handleSubmit,
      register,
      errors,
      getValues,
      setError,
      clearError,
      setValue,
      reset,
      watch,
      formState: { dirtyFields }
    } = useForm({ mode: "onChange" });

  const handleDateChange = (date: Date | null, type: string) => {
    switch(type){ 
      case 'XML':
        setValue('fechaCargaXML', moment(date).format('YYYY-MM-DD'))
        setSelectedDateXML(date);
        break;
      case 'CLOSING_DATE':
        setValue('fechaCierre', moment(date).format('YYYY-MM-DD'))
        setActiveOptionButton({...activeOptionButton, xmlMeller: true})
        setSelectedDateClosingDate(date);
        handleDate(date, type)
        break;
    }
  };

  const handleResetForm = () => {
    setActiveOptionButton({...activeOptionButton, xmlMeller: false})
    setSelectedDateXML(null)
      setValue('fechaCargaXML', '')
      setValue('fechaCierre', '')
    setSelectedDateClosingDate(null)
    reset()
    handleReset({})
  }

  return (
    <>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="filters-of-rrvv__filters">
        <select name="estado" ref={register}>
          {hadleFilter(codProd).map(({ value, lable }: any) => (
            <option key={value} value={value}>
              {lable}
            </option>
          ))}
        </select>
        <InputField placeHolder="CUSPP" name="CUSPP" register={register} maxLegth={12} />
        <InputField placeHolder="N° de Operación" name="nroOperacion" register={register} maxLegth={12} />
        <InputField name="numeroDocumento" register={register} placeHolder="N° de documento" maxLegth={9} />

        <input type="hidden" name="fechaCargaXML" ref={register} />
        <input type="hidden" name="fechaCierre" ref={register} />

        <div className="inputSearch-form">
          <div className={`workData__form__item area--${(1 % 5) % 4} child `}>
            <div className={`datapicker-single`}>
              <div className="datapicker-single__body">
                <div>
                  <label className="datapicker__label">Fecha carga XML</label>
                </div>
                <DateTimePicker
                  name="fechaCargaXML"
                  format="dd-MM-yy"
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yy"
                  calendarIcon={<img src={CalendarIcon} />}
                  clearIcon={null}
                  value={selectedDateXML}
                  onChange={(e) => handleDateChange(e, 'XML')}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="inputSearch-form">
          <div className={`workData__form__item area--${(1 % 5) % 4} child `}>
            <div className={`datapicker-single`}>
              <div className="datapicker-single__body">
                <div>
                  <label className="datapicker__label">Fecha de cierre</label>
                </div>
                <DateTimePicker
                  name="fechaCierre"
                  format="dd-MM-yy"
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yy"
                  calendarIcon={<img src={CalendarIcon} />}
                  clearIcon={null}
                  value={selectedDateClosingDate}
                  onChange={(e) => handleDateChange(e, 'CLOSING_DATE')}
                />
              </div>
            </div>
          </div>
        </div>

        <InputField placeHolder="Nomb. y Apellido" name="nombresYApellidos" register={register} />
      </div>

      <div className="filters-of-rrvv__actions">
        <button
          type="submit"
          className="btn">
          Continuar
        </button>
        <div className="clean-filter" onClick={handleResetForm}>
          <IconDelete /> Borrar filtros
        </div>
      </div>
      </form>
    </>
  );
};
